import React, { ReactElement } from 'react'
import { Text } from '@chakra-ui/react'
import { formatDate } from '@rw1/utilities'
import { TTableCell } from '../types'
import { useColor } from '../../../theme'

type TDateFormatterFn = (date: Date) => string

export const dateCell: ({
  formatter,
  isSecondaryText,
  margin,
}: {
  formatter?: TDateFormatterFn
  isSecondaryText?: boolean
  margin?: string
}) => TTableCell<Date> =
  ({ formatter = formatDate, isSecondaryText = false, margin }) =>
  (date): ReactElement => {
    const mainColor = useColor({ nuance: 5, palette: 'text' })
    const secondaryColor = useColor({ nuance: 2, palette: 'text' })

    return (
      <Text
        color={isSecondaryText ? secondaryColor : mainColor}
        fontSize={isSecondaryText ? 'sm' : 'md'}
        letterSpacing={isSecondaryText ? '0.02em' : 'auto'}
        margin={margin}
        whiteSpace="nowrap">
        {formatter(date)}
      </Text>
    )
  }
